import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type UpdateOrganization = "UPDATE_ORGANIZATION";
export const UPDATE_ORGANIZATION: UpdateOrganization = "UPDATE_ORGANIZATION";
export type UpdateOrganizationEnd = "UPDATE_ORGANIZATION_END";
export const UPDATE_ORGANIZATION_END: UpdateOrganizationEnd = "UPDATE_ORGANIZATION_END";

export interface UpdateOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        organization: Organization;
    };
    type: UpdateOrganization;
}

export function updateOrganization(
    organization: Organization
): ThunkAction<void, State, undefined, UpdateOrganizationAction> {
    return (dispatch: Dispatch<UpdateOrganizationAction>, getState) => {
        const state = getState();

        dispatch(updateOrganizationWithCreds(state.auth.credentials, organization));
    };
}

function updateOrganizationWithCreds(credentials: Credentials, organization: Organization): UpdateOrganizationAction {
    return {
        payload: {
            credentials,
            organization
        },
        type: UPDATE_ORGANIZATION
    };
}

export interface UpdateOrganizationEndAction extends Action {
    payload: {
        organization?: Organization;
        error?: Error;
    };
    type: UpdateOrganizationEnd;
}

export function updateOrganizationEnd(error: Error, organization?: Organization): UpdateOrganizationEndAction {
    return {
        payload: {
            error,
            organization
        },
        type: UPDATE_ORGANIZATION_END
    };
}
